export function canonicalizeSlotTime(value) {
  if (value === null || value === undefined) return null;

  const source = String(value).trim();
  if (!source) return null;

  const directMatch = source.match(/^\d{1,2}:\d{2}$/);
  if (directMatch) {
    const [hours, minutes] = source.split(":").map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  const withSeconds = source.match(/^\d{1,2}:\d{2}:\d{2}$/);
  if (withSeconds) {
    const [hours, minutes] = source.split(":").slice(0, 2).map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  const meridiemMatch = source.match(/^(\d{1,2}):(\d{2})\s*([AP]M)$/i);
  if (meridiemMatch) {
    let hours = Number(meridiemMatch[1]);
    const minutes = Number(meridiemMatch[2]);
    const period = meridiemMatch[3].toUpperCase();
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    if (period === "AM") {
      hours = hours === 12 ? 0 : hours;
    } else if (period === "PM") {
      hours = hours === 12 ? 12 : hours + 12;
    }
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  return null;
}

export function normalizeSlotCollection(items = []) {
  const slotMap = new Map();

  (Array.isArray(items) ? items : []).forEach((slot, index) => {
    const rawTime = slot?.time ?? slot?.slotTime ?? slot;
    const time = canonicalizeSlotTime(rawTime);
    if (!time) return;

    const existing = slotMap.get(time);
    const normalized = {
      ...(existing ?? {}),
      ...(slot && typeof slot === "object" ? slot : { time }),
      time,
      id: existing?.id ?? slot?.id ?? slot?.scheduleId ?? `${time}-${index}`,
      blocked: Boolean(existing?.blocked || slot?.blocked || existing?.booked || slot?.booked || existing?.isBooked || slot?.isBooked),
      booked: Boolean(existing?.booked || slot?.booked || existing?.isBooked || slot?.isBooked),
    };

    slotMap.set(time, normalized);
  });

  return Array.from(slotMap.values()).sort((a, b) => (a.time || "").localeCompare(b.time || ""));
}
